import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useNavigationState } from '@react-navigation/native';

import { Modal } from '@pimm/base';
import { useAuthToken } from '@app/features/app';
import { DayBlock, Daypart, useSiteTime } from '@app/features/store-core';
import { DashboardModalType, useDashboard } from '@app/features/dashboard';
import { EmployeeCelebration } from '@app/features/calendar/components/employee-celebration';
import { useDayBlockScheduler, useSiteConfig } from '@app/features/store-core';
import { useCalendarEvents } from '@app/features/calendar';
import { CalendarSnooze } from '@app/features/calendar/store/calendar.store';

export const ModalEmployeeCelebration = () => {
  const { user } = useAuthToken();
  const { siteConfig } = useSiteConfig();
  const { events, getEventsByDate } = useCalendarEvents();
  const { modal, toggleModal } = useDashboard();
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();
  const siteTime = useSiteTime();
  /** Once user cancels, don't show again until they leave and re-enter PositionGuide. */
  const numOfEvents = useMemo(() => events.length, [events]);

  // prettier-ignore
  const promptCelebration = useCallback(async (dayblock: DayBlock) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    const eventToday = getEventsByDate(siteTime?.toDayBlockNow()?.startTime);
    if (siteConfig?.id && user?.userId && !modal?.type) {
      if (eventToday.length > 0) {
        const snoozeData = await CalendarSnooze.get(siteConfig.id, user.userId);
        if (!snoozeData.timestamp || snoozeData.timestamp < dayblock.startTime) {
          timeoutRef.current = setTimeout(() => {
            toggleModal({ type: DashboardModalType.EmployeeCelebration, payload: { autoSave: true } });
          }, 1000);
        }
      }
    }
  }, [siteConfig?.id, modal?.type, user?.userId, getEventsByDate, toggleModal]);

  useDayBlockScheduler({
    isActive: !!siteConfig.id && !modal?.type && numOfEvents > 0,
    siteId: siteConfig.id,
    onChange: promptCelebration,
  });

  return (
    <Modal
      size="lg"
      _content={{ rounded: '2xl', p: 0, maxW: 550 }}
      isOpen={modal?.type === DashboardModalType.EmployeeCelebration}
      hideClose
    >
      <EmployeeCelebration autoSave={modal?.payload?.autoSave} onClose={() => toggleModal()} />
    </Modal>
  );
};
